import React, { useState } from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import agentUsersResource from 'src/actions/agentUsers/agentUsersResource';
import { Button, ButtonTypes } from 'src/presentation/components/agent_desktop_components';
import CsvUploadModal from './components/CsvUploadModal';
import RouterLinkButton from 'src/presentation/components/RouterLinkButton';
import useRoles from 'src/presentation/components/pages/people/hooks/useRoles';

const dataAidPrefix = 'admin-users-page';

const UsersActions = ({ root }): JSX.Element => {
  const dispatch = useDispatch();

  const { roles } = useRoles();
  const history = useHistory();
  const [isCvsUploadModalVisible, setCsvUploadModalVisible] = useState<boolean>(false);

  const handleUploadCsv = () => setCsvUploadModalVisible(true);
  const handleCloseCsvModal = () => setCsvUploadModalVisible(false);
  const openUserSettings = () => {
    history.push({ pathname: '/users/settings', search: history.location.search });
  };

  const handleDownloadCsv = () => {
    dispatch(agentUsersResource.effects.downloadCsvFile(roles));
  };

  const exportButton = (
    <ButtonWithMargin
      data-aid="action-button-export-csv"
      onClick={handleDownloadCsv}
      buttonType={ButtonTypes.SECONDARY}
    >
      Export
    </ButtonWithMargin>
  );

  const importButton = (
    <ButtonWithMargin data-aid="action-button-csv" onClick={handleUploadCsv} buttonType={ButtonTypes.SECONDARY}>
      Import
    </ButtonWithMargin>
  );

  const settingsButton = (
    <ButtonWithMargin data-aid="settings-button" onClick={openUserSettings} buttonType={ButtonTypes.SECONDARY}>
      Settings
    </ButtonWithMargin>
  );

  const addUserButton = (
    <RouterLinkButton
      data-aid={`${dataAidPrefix}-addButton`}
      to={location => ({ ...location, pathname: `${root}/new` })}
    >
      Add user
    </RouterLinkButton>
  );

  const renderActionButtons = (
    <>
      {exportButton}
      {importButton}
      {settingsButton}
      {addUserButton}
    </>
  );

  return (
    <>
      {renderActionButtons}
      {isCvsUploadModalVisible && <CsvUploadModal onClose={handleCloseCsvModal} />}
    </>
  );
};

const ButtonWithMargin = styled(Button)`
  margin-right: 8px;
`;

export default React.memo(UsersActions);
